export default function IconTrophy({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M8.99988 22H14.9999M11.9999 16.25V22M18.8999 11L19.4998 11C20.2955 11 21.0585 10.6839 21.6211 10.1213C22.1837 9.55873 22.4998 8.79567 22.4998 8.00002V5.75002C21.0353 5.75002 18.7498 5.75002 18.7498 5.75002M5.09988 11L4.48779 11C3.69214 11 2.92908 10.6839 2.36647 10.1213C1.80386 9.55873 1.48779 8.79567 1.48779 8.00002V5.75002H5.23779M5.24988 3.5C5.24988 5.81006 5.24988 9.41528 5.24988 9.41528C5.24988 13.1372 8.22688 16.2222 11.9487 16.2498C12.8394 16.2566 13.7226 16.087 14.5475 15.7508C15.3723 15.4146 16.1225 14.9185 16.7547 14.291C17.3869 13.6636 17.8887 12.9172 18.2312 12.0949C18.5736 11.2727 18.7499 10.3907 18.7499 9.50001L18.7498 3.50001C18.7498 3.50001 10.2291 3.50001 5.24988 3.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
